import _sfc_main from "./component-library299.mjs";
import "./component-library300.mjs";
import normalizeComponent from "./component-library82.mjs";
var _sfc_render = function render() {
  var _vm = this, _c = _vm._self._c, _setup = _vm._self._setupProxy;
  return _c("div", { staticClass: "variant-selector" }, [_vm.displayName !== "Preis" ? _c("span", [_vm._v(_vm._s(_vm.displayName) + ": " + _vm._s(_setup.activeVariantName))]) : _vm._e(), _setup.isColorSelector ? _c(_setup.VariantSelectorColor, { staticClass: "variant-selector__entry", attrs: { "variants": _vm.variants, "value": _setup.activeVariantIndex }, on: { "select-variant": (args) => _vm.$emit("select-variant", args) } }) : _c(_setup.VariantSelectorBasic, { staticClass: "variant-selector__entry", attrs: { "variants": _vm.variants }, on: { "select-variant": (args) => _vm.$emit("select-variant", args) } })], 1);
};
var _sfc_staticRenderFns = [];
var __component__ = /* @__PURE__ */ normalizeComponent(
  _sfc_main,
  _sfc_render,
  _sfc_staticRenderFns,
  false,
  null,
  "915b09b0",
  null,
  null
);
const VariantSelector = __component__.exports;
export {
  VariantSelector as default
};
